import { InternalNavigationLink } from '../../components';
import envReader from '../../config/envReader';
import { ObjectKeyValueString } from '../../helpers/types';
import { useContent } from '../../hooks/use-content';
import { AVAILABLE_CONTENT_LANG } from '../../i18n/content';

interface TermsOfUseUsAnnexOnePageProps {
  lang: string
}

export const TermsOfUseUsAnnexOnePage = ({ lang }: TermsOfUseUsAnnexOnePageProps) => {
  const content = useContent(lang);
  const contentKeyAnnex = content.t('portal.termsOfUse.annex');

  const langDocMap: ObjectKeyValueString = {
    [AVAILABLE_CONTENT_LANG.en_US]: 'terms_of_use_eb_partner_portal_us_and_can_supplemental_terms_(150152.1).pdf',
    [AVAILABLE_CONTENT_LANG.fr_CA]: 'terms_of_use_eb_partner_portal_us_and_can_supplemental_terms_(150152.1)_fr-ca.pdf',
  };

  const absolutePath = `${envReader.VITE_PUBLIC_URL}/terms-of-use-us/annex-1/${langDocMap[lang]}`;

  return (
    <InternalNavigationLink
      href={absolutePath}
      text={contentKeyAnnex}
    />
  );
};
